import { Translations } from './translations';

const es: Translations = {
  common: {
    about: 'Acerca de',
    solutions: 'Soluciones',
    otherServices: 'Servicios',
    contact: 'Contacto',
    language: 'Idioma',
    learnMore: 'Más información',
    address: 'Dónde encontrarnos',
    letsChat: 'Hablemos',
  },
  home: {
    intro: {
      title: '¿Te quedaste sin batería en la carretera?',
      text: 'Evita sorpresas, nuestro sistema avisa antes de la falla. ¡Más seguridad, menos paradas y más ahorro!',
      button: [{ title: 'Más Información' }],
    },
    middleBlock: {
      title: 'Hecho para cualquier carretera, cualquier vehículo',
      text: 'Nuestro sistema monitorea tus baterías en tiempo real y avisa antes de la falla, evitando paradas y pérdidas.',
      button: 'Contáctanos',
    },
    about: {
      title: 'Inteligente y Adaptativo',
      text: 'Monitoreo en tiempo real de la batería con sensores e I.A., ¡como un laboratorio en miniatura dentro de tu vehículo!',
      section: [
        { title: '¡Pequeña inversión, gran retorno!', content: 'Instalación rápida y fácil en cualquier vehículo.', icon: '' },
        { title: '¡Bajísimo Consumo!', content: 'Funciona con poca energía y no afecta el rendimiento del vehículo.', icon: '' },
      ],
    },
    contact: {
      title: 'Ponte en Contacto',
      text: '¡Habla con Vizage y conoce nuestras soluciones!',
    },
    devices: {
      title: 'Nuestros Dispositivos',
      content: 'Descubre nuestra línea completa de monitores de baterías.',
    },
    otherServices: {
      title: 'Conoce otros servicios',
      subtitle: 'Soluciones complementarias para monitoreo, prevención de fallas y gestión de sistemas críticos.',
      items: [
        {
          title: 'Monitoreo de Generadores',
          subtitle: 'Supervisa baterías y condiciones críticas de generadores para reducir fallas y paradas inesperadas.',
          icon: 'svg/generator.svg',
        },
        {
          title: 'Monitoreo de UPS',
          subtitle: 'Supervisa baterías de sistemas UPS e identifica señales de falla antes de que afecten tu operación.',
          icon: 'svg/nobreak.svg',
        },
        {
          title: 'Monitoreo Externo Vizage',
          subtitle: 'Nuestro equipo supervisa tus equipos, analiza alertas y ayuda a identificar problemas de forma preventiva.',
          icon: 'svg/monitoring.svg',
        },
      ],
    },
    supports: 'Apoyos',
  },
  footer: {
    tellUsEverything: 'Cuéntanos sobre tus necesidades',
    doYouHaveQuestion: '¿Listo para prevenir fallas de baterías? Hablemos de tus necesidades de monitoreo.',
  },
  links: {
    title: 'Monitoreo que anticipa el futuro.',
    bio: 'Soluciones inteligentes para supervisar la salud de tus baterías en tiempo real.',
    items: {
      company: { label: 'Conoce Vizage', description: 'Tecnología para el monitoreo inteligente de baterías' },
      whatsapp: { label: 'Habla con nuestro equipo', description: 'Contáctanos por WhatsApp' },
      email: { label: 'Envíanos un correo', description: 'Contacta directamente al equipo Vizage' },
      linkedin: { label: 'Sigue a Vizage en LinkedIn', description: 'Noticias, proyectos y novedades' },
      instagram: { label: 'Síguenos en Instagram', description: 'Contenido y actualizaciones de Vizage' },
    },
    socialLabels: {
      whatsapp: 'Vizage en WhatsApp',
      email: 'Enviar un correo a Vizage',
      linkedin: 'Vizage en LinkedIn',
      instagram: 'Vizage en Instagram',
    },
    footer: 'VIZAGE TECNOLOGIA LTDA',
  },
  devices: {
    vizageNode: 'Vizage Node',
    vizageMesh: 'Vizage Mesh',
    oneTimePayment: 'Pago único',
    localAlert: 'Alerta local',
    bluetoothConnection: 'Conexión Bluetooth',
    singleVehicle: 'Solo puede usarse en 1 vehículo',
    findNearbyShops: 'Encuentra talleres cercanos',
    cloudAlert: 'Alerta en la nube',
    wirelessCommunication: 'Comunicación inalámbrica',
    onlineManagement: 'Plataforma de gestión online',
    unlimitedVehicles: 'Vehículos ilimitados',
    personalizedSupport: 'Soporte personalizado',
  },
};

export default es;
